Controller = App.loadClass 'core::Angular/Controller'

class exports.MainController extends Controller
    constructor: (@scope, @transitions, @modal) ->
        super(@scope, @transitions)

        # @scope.editEmailPassOptions = @editEmailPassOptions
        @scope.editContactInfo = @editContactInfo
        @scope.editBackground = @editBackground
        @scope.setLocale = @setLocale
        @scope.editEmailPassOptions = {
            ngbModalOptions: {
                windowClass: 'extra-small-form'
            }
        }

        window.addEventListener 'username.dropdown.contactInfo:save', (event) =>
            @scope.user_name = event.detail.first_name + ' ' + event.detail.last_name

    editContactInfo: (additionalValidation = false) =>
        @modal.open
            windowClass: 'small_dialog'
            templateUrl: 'backend/username-dropdown/edit-contact-info'
            controller: 'UsernameDropdown.Controllers.ContactInfoController'
            resolve:
                'userData': ['UsernameDropdown.Services.UserService', (repo) ->
                    # when additional validation/info is required, we need to reference the safe link user
                    return if additionalValidation then repo.getSafelinkUser() else repo.getLoggedInUser()
                ]
                'states': ['UsernameDropdown.Services.UserService', (repo) ->
                    return repo.getStates()
                ],
                'additionalValidation': () ->
                    return additionalValidation


    editBackground: () =>
        @modal.open
            windowClass: 'medium_dialog'
            templateUrl: 'backend/username-dropdown/edit-background'
            controller: 'UsernameDropdown.Controllers.BackgroundController'
            resolve:
                'userData': ['UsernameDropdown.Services.UserService', (repo) ->
                    return repo.getLoggedInUser()
                ],
                'backgroundOptions': ['UsernameDropdown.Services.UserService', (repo) ->
                    return repo.getBackgroundOptions()
                ]


    setLocale: () =>
        @modal.open
            windowClass: 'small_dialog'
            templateUrl: 'backend/username-dropdown/set-locale'
            controller: 'UsernameDropdown.Controllers.LocaleController'
            resolve:
                'userData': ['UsernameDropdown.Services.UserService',  (repo) ->
                    return repo.getLoggedInUser()
                ],

                'locales': ['UsernameDropdown.Services.UserService',  (repo) ->
                    return repo.getLocales()
                ]

